import { get, pipe } from 'lodash/fp';
import { createSelector } from 'reselect';
import workspaceSelector from './workspaceSelector';

const boardsSelector = createSelector(workspaceSelector, pipe(get('boards')));

export default boardsSelector;
